// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ArWhatsappPhoneController from "./ar_whatsapp_phone_controller.js"
application.register("ar-whatsapp-phone", ArWhatsappPhoneController)

import BlockCopyPasteController from "./block_copy_paste_controller.js"
application.register("block-copy-paste", BlockCopyPasteController)

import BsModalController from "./bs_modal_controller.js"
application.register("bs-modal", BsModalController)

import BsPopoverController from "./bs_popover_controller.js"
application.register("bs-popover", BsPopoverController)

import BuscarReportesController from "./buscar_reportes_controller.js"
application.register("buscar-reportes", BuscarReportesController)

import ClinicHistoryTabsController from "./clinic_history_tabs_controller.js"
application.register("clinic-history-tabs", ClinicHistoryTabsController)

import CollapseController from "./collapse_controller.js"
application.register("collapse", CollapseController)

import ConsentimientosController from "./consentimientos_controller.js"
application.register("consentimientos", ConsentimientosController)

import ConsentimientosFirmasRepresentantesController from "./consentimientos_firmas_representantes_controller.js"
application.register("consentimientos-firmas-representantes", ConsentimientosFirmasRepresentantesController)

import CustomTabsController from "./custom_tabs_controller.js"
application.register("custom-tabs", CustomTabsController)

import DatepickerController from "./datepicker_controller.js"
application.register("datepicker", DatepickerController)

import DatepickerRangeLimitedController from "./datepicker_range_limited_controller.js"
application.register("datepicker-range-limited", DatepickerRangeLimitedController)

import DecimalInputController from "./decimal_input_controller.js"
application.register("decimal-input", DecimalInputController)

import DescripcionImagenController from "./descripcion_imagen_controller.js"
application.register("descripcion-imagen", DescripcionImagenController)

import DniMaskController from "./dni_mask_controller.js"
application.register("dni-mask", DniMaskController)

import DocumentSelectController from "./document_select_controller.js"
application.register("document-select", DocumentSelectController)

import DownloadExcelController from "./download_excel_controller.js"
application.register("download-excel", DownloadExcelController)

import DrogasVasoactivasController from "./drogas_vasoactivas_controller.js"
application.register("drogas-vasoactivas", DrogasVasoactivasController)

import DropdownPreventCloseController from "./dropdown_prevent_close_controller.js"
application.register("dropdown-prevent-close", DropdownPreventCloseController)

import DropzoneController from "./dropzone_controller.js"
application.register("dropzone", DropzoneController)

import EpicrisisArmController from "./epicrisis_arm_controller.js"
application.register("epicrisis-arm", EpicrisisArmController)

import FilterConsumosFarmaciasController from "./filter_consumos_farmacias_controller.js"
application.register("filter-consumos-farmacias", FilterConsumosFarmaciasController)

import FilterIndicacionesMedicasController from "./filter_indicaciones_medicas_controller.js"
application.register("filter-indicaciones-medicas", FilterIndicacionesMedicasController)

import FilterPrestacionesController from "./filter_prestaciones_controller.js"
application.register("filter-prestaciones", FilterPrestacionesController)

import FilterProfesionalesPrestacionesController from "./filter_profesionales_prestaciones_controller.js"
application.register("filter-profesionales-prestaciones", FilterProfesionalesPrestacionesController)

import FormDownloadSpinnerController from "./form_download_spinner_controller.js"
application.register("form-download-spinner", FormDownloadSpinnerController)

import FormUtilsController from "./form_utils_controller.js"
application.register("form-utils", FormUtilsController)

import FormValidatorController from "./form_validator_controller.js"
application.register("form-validator", FormValidatorController)

import GlasgowController from "./glasgow_controller.js"
application.register("glasgow", GlasgowController)

import GuardiaController from "./guardia_controller.js"
application.register("guardia", GuardiaController)

import ImageOrderPrestacionesLimitController from "./image_order_prestaciones_limit_controller.js"
application.register("image-order-prestaciones-limit", ImageOrderPrestacionesLimitController)

import ImageUrlGeneratorController from "./image_url_generator_controller.js"
application.register("image-url-generator", ImageUrlGeneratorController)

import IndicacionDetalleFormController from "./indicacion_detalle_form_controller.js"
application.register("indicacion-detalle-form", IndicacionDetalleFormController)

import IndicacionMedicaTabuladoController from "./indicacion_medica_tabulado_controller.js"
application.register("indicacion-medica-tabulado", IndicacionMedicaTabuladoController)

import IndicacionesBufferController from "./indicaciones_buffer_controller.js"
application.register("indicaciones-buffer", IndicacionesBufferController)

import IndicacionesFormsController from "./indicaciones_forms_controller.js"
application.register("indicaciones-forms", IndicacionesFormsController)

import IndicacionesMedicasController from "./indicaciones_medicas_controller.js"
application.register("indicaciones-medicas", IndicacionesMedicasController)

import IndicacionesMedicasOfficeController from "./indicaciones_medicas_office_controller.js"
application.register("indicaciones-medicas-office", IndicacionesMedicasOfficeController)

import IndicacionesMedicasOfficePickerController from "./indicaciones_medicas_office_picker_controller.js"
application.register("indicaciones-medicas-office-picker", IndicacionesMedicasOfficePickerController)

import InformePlantillasController from "./informe_plantillas_controller.js"
application.register("informe-plantillas", InformePlantillasController)

import InplaceController from "./inplace_controller.js"
application.register("inplace", InplaceController)

import InternacionAutocompleteController from "./internacion_autocomplete_controller.js"
application.register("internacion-autocomplete", InternacionAutocompleteController)

import LaboratorioController from "./laboratorio_controller.js"
application.register("laboratorio", LaboratorioController)

import LinkedAutocompleteController from "./linked_autocomplete_controller.js"
application.register("linked-autocomplete", LinkedAutocompleteController)

import MasterPasswordAuditoresController from "./master_password_auditores_controller.js"
application.register("master-password-auditores", MasterPasswordAuditoresController)

import ModalsController from "./modals_controller.js"
application.register("modals", ModalsController)

import NotificationsController from "./notifications_controller.js"
application.register("notifications", NotificationsController)

import OrdenServicioFormValidationController from "./orden_servicio_form_validation_controller.js"
application.register("orden-servicio-form-validation", OrdenServicioFormValidationController)

import PedidoFechaHoraController from "./pedido_fecha_hora_controller.js"
application.register("pedido-fecha-hora", PedidoFechaHoraController)

import PedidoFormValidationController from "./pedido_form_validation_controller.js"
application.register("pedido-form-validation", PedidoFormValidationController)

import PlanByObraSocialController from "./plan_by_obra_social_controller.js"
application.register("plan-by-obra-social", PlanByObraSocialController)

import PrestacionesActionController from "./prestaciones_action_controller.js"
application.register("prestaciones-action", PrestacionesActionController)

import PreventReturnKeyController from "./prevent_return_key_controller.js"
application.register("prevent-return-key", PreventReturnKeyController)

import ProtocoloModeloLinkerController from "./protocolo_modelo_linker_controller.js"
application.register("protocolo-modelo-linker", ProtocoloModeloLinkerController)

import ReporteFacturacionController from "./reporte_facturacion_controller.js"
application.register("reporte-facturacion", ReporteFacturacionController)

import RespiratorioArmController from "./respiratorio_arm_controller.js"
application.register("respiratorio-arm", RespiratorioArmController)

import SearchPacientesController from "./search_pacientes_controller.js"
application.register("search-pacientes", SearchPacientesController)

import SearchPacientesGuardiaController from "./search_pacientes_guardia_controller.js"
application.register("search-pacientes-guardia", SearchPacientesGuardiaController)

import SelectAllController from "./select_all_controller.js"
application.register("select-all", SelectAllController)

import SelectHoraController from "./select_hora_controller.js"
application.register("select-hora", SelectHoraController)

import SelectPedidosController from "./select_pedidos_controller.js"
application.register("select-pedidos", SelectPedidosController)

import SessionActivityController from "./session_activity_controller.js"
application.register("session-activity", SessionActivityController)

import SignaturePadController from "./signature_pad_controller.js"
application.register("signature-pad", SignaturePadController)

import SpinnerController from "./spinner_controller.js"
application.register("spinner", SpinnerController)

import TabTitleController from "./tab_title_controller.js"
application.register("tab-title", TabTitleController)

import TagifyController from "./tagify_controller.js"
application.register("tagify", TagifyController)

import TimepickerController from "./timepicker_controller.js"
application.register("timepicker", TimepickerController)

import ToastrController from "./toastr_controller.js"
application.register("toastr", ToastrController)

import ToggleCarpetaRevisadaController from "./toggle_carpeta_revisada_controller.js"
application.register("toggle-carpeta-revisada", ToggleCarpetaRevisadaController)

import ToggleController from "./toggle_controller.js"
application.register("toggle", ToggleController)

import ToggleIndicacionMedicaController from "./toggle_indicacion_medica_controller.js"
application.register("toggle-indicacion-medica", ToggleIndicacionMedicaController)

import ToggleLaboratorioController from "./toggle_laboratorio_controller.js"
application.register("toggle-laboratorio", ToggleLaboratorioController)

import ToggleViasController from "./toggle_vias_controller.js"
application.register("toggle-vias", ToggleViasController)

import TomSelectController from "./tom_select_controller.js"
application.register("tom-select", TomSelectController)

import TrixReadonlyController from "./trix_readonly_controller.js"
application.register("trix-readonly", TrixReadonlyController)

import TurboController from "./turbo_controller.js"
application.register("turbo", TurboController)

import TurnosDatepickerController from "./turnos_datepicker_controller.js"
application.register("turnos-datepicker", TurnosDatepickerController)

import TurnosFormValidationController from "./turnos_form_validation_controller.js"
application.register("turnos-form-validation", TurnosFormValidationController)

import ValidationMatriculaController from "./validation_matricula_controller.js"
application.register("validation-matricula", ValidationMatriculaController)

import WhatsappModalController from "./whatsapp_modal_controller.js"
application.register("whatsapp-modal", WhatsappModalController)
